import { Palette, assignColors } from "./colors"

// Tailwind colors for health professionals
const professionalColors = [
  "text-chat-orange",
  "text-chat-green",
  "text-chat-purple",
  "text-chat-lavender",
  "text-chat-red",
] as const

const professionalPalette: Palette = (index) => professionalColors[index % professionalColors.length]

/**
 * Tailwind text color for patients. Deliberately outside the professional
 * palette so users/patients can easily distinguish between the two.
 */
export const PATIENT_COLOR = "text-blue-400"

/**
 * Assigns each professional a stable Tailwind text color within a conversation:
 * professionals cycle the chat palette in order of first appearance and keep
 * their color for the lifetime of this instance.
 */
export class ConversationColors {
  private readonly colorsByConversation = new Map<string, Map<string, string>>()

  getProfessionalColor(conversationId: string, userName: string): string {
    let colors = this.colorsByConversation.get(conversationId)
    if (!colors) {
      colors = new Map()
      this.colorsByConversation.set(conversationId, colors)
    }
    return assignColors(colors, [userName], professionalPalette).get(userName)!
  }
}

/** App-wide instance so participant colors stay stable for the lifetime of the page. */
export const conversationColors = new ConversationColors()
